import React from 'react';
import { BrandMark } from '../BrandMark';

/**
 * 9:16 share card (Instagram Stories / WhatsApp status).
 * Deep Green surface, subtle BEELYV mark, content supplied by the caller.
 * Callers must pass only content the user explicitly chose to include.
 */
export function ShareCardFrame({
  children,
  label
}: {
  children: React.ReactNode;
  label: string;
}) {
  return <figure aria-label={label} className="relative mx-auto flex aspect-[9/16] w-full max-w-[260px] flex-col overflow-hidden rounded-panel bg-deep p-3 text-sand shadow-lift" data-id="element-724" data-mp="2wnx2llcnrauf">
      <div className="flex items-center gap-1" data-id="element-725" data-mp="2rr6miy0usf90">
        <BrandMark size={24} data-id="element-726" data-mp="36n4avu4jcfao" />
        <span className="bee-overline text-[9px] font-bold text-ondark" data-id="element-727" data-mp="36ne2fm58auih">Beelyv</span>
      </div>
      <div className="flex flex-1 flex-col justify-center" data-id="element-728" data-mp="31losk9tqsmvz">{children}</div>
      <p className="text-[9.5px] text-ondark" data-id="element-729" data-mp="luj0u0jdcix8">beelyv.app</p>
    </figure>;
}